export enum StepStatus {
  Preview,
  Active,
  InProgress,
  Complete,
}
